namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass('Matrix.Dashboards.HierarchicalDiagramWidgetDesigner')
    export class HierarchicalDiagramWidgetDesigner implements IWidgetDesigner {
        private dialog: IWidgetDesignerDialog;

        private get keyField() {
            return this.dialog.getEditor("KeyField", FieldSelect);
        }

        private get parentKeyField() {
            return this.dialog.getEditor("ParentKeyField", FieldSelect);
        }

        private get labelField() {
            return this.dialog.getEditor("LabelField", FieldSelect);
        }

        init(dialog: IWidgetDesignerDialog) {
            this.dialog = dialog;
            this.dialog.getDatasetEditor().changeSelect2(() => this.dialog?.getDatasetColumns(columns => this.updateFieldsFrom(columns, true)));

            const themeLookup = this.dialog.getEditor("GraphTheme", Serenity.LookupEditor);
            if (themeLookup.items.length === 1 && themeLookup.items[0].id === "Default")
                themeLookup.getGridField().hide();
        }

        onLoad() {
            this.dialog?.getDatasetColumns(columns => this.updateFieldsFrom(columns, false));
        }

        updateFieldsFrom(columns: Data.DataColumn[], setDefaults: boolean) {
            const fields = (columns ?? []).map(x => <Serenity.Select2Item>{
                id: x.Name,
                text: x.Name
            });

            this.keyField.items = fields;
            this.parentKeyField.items = fields;
            this.labelField.items = fields;

            if (setDefaults) {
                fields.length && (this.keyField.value = fields[0].id);
                fields.length > 1 && (this.parentKeyField.value = fields[1].id);
                fields.length > 2 && (this.labelField.value = fields[2].id);
            }
        }

        destroy() {
            this.dialog = null;
        }
    }
}